import * as Sentry from "@sentry/browser";
import { Integrations } from "@sentry/tracing";
Sentry.init({
    dsn: "https://edb119542c024580adea6bb033eae672@o90177.ingest.sentry.io/6419162",
    release: "proell-neos@" + process.env.npm_package_version,
    integrations: [new Integrations.BrowserTracing()],
    tracesSampleRate: 1.0, // We recommend adjusting this in production
});
